/**
 * Shared UI Provider state types.
 *
 * Both `TuiProvider` (cell-grid CLI) and `WebUIProvider` (canvas-
 * based SPA) build on top of `UIProvider`, which is a template-
 * method base class that owns these state shapes and emits
 * `state:changed` whenever they mutate. Subclasses override the
 * `paintX` hooks to render the same state in their own way.
 */
export const initialUIState = {
    title: 'INPA',
    screenHandle: null,
    screenCyclic: false,
    // INPA palette codes — `1 = C_BLACK`, `0 = C_WHITE`. Real INPA paints
    // black text on a white canvas by default; scripts that don't call
    // `setcolor(...)` first should still come out reading correctly.
    fg: 1,
    bg: 0,
    menuTitle: '',
    menuHandle: null,
    menuItems: [],
    textLines: [],
    analogValues: [],
    digitalValues: [],
    hexDumps: [],
    userBoxes: new Map(),
    firstVisibleLine: 0,
    visibleLineCount: 0,
    totalLines: 0,
    inputDialog: null,
    inputResolve: null,
    lastInputState: 0,
};
/** @deprecated Use `initialUIState`. */
export const initialTuiState = initialUIState;
//# sourceMappingURL=state.js.map